import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=db262dfa&scoped=true"
import script from "./Comments.vue?vue&type=script&lang=ts"
export * from "./Comments.vue?vue&type=script&lang=ts"
import style0 from "./Comments.vue?vue&type=style&index=0&id=db262dfa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db262dfa",
  null
  
)

export default component.exports